export const FEATURE_FLAG_QUOTES = "quotes";
